/**
 * Centralized status color tokens per spec.md "Status semantics (chips)".
 * Color is never the only signal — every chip carries its status text too.
 */
export const STATUS_TOKENS = {
  draft:    { bg: '#F1F3F9', fg: '#000000', label: 'Draft',    rail: '#9CA3AF' },
  sent:     { bg: '#000000', fg: '#FFFFFF', label: 'Sent',     rail: '#000000' },
  viewed:   { bg: '#FFFBEB', fg: '#B7791F', label: 'Viewed',   rail: '#FBBF24' },
  signed:   { bg: '#E6F4EC', fg: '#1F8A4C', label: 'Signed',   rail: '#1F8A4C' },
  declined: { bg: '#FD8A8A', fg: '#000000', label: 'Declined', rail: '#FF0004' },
  expired:  { bg: '#F1F3F9', fg: '#64748B', label: 'Expired',  rail: '#64748B' },
};

export const TERMINAL_STATUSES = new Set(['signed', 'declined', 'expired']);

export const getStatusToken = (status) =>
  STATUS_TOKENS[status] || STATUS_TOKENS.draft;
